// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase() {
  return {
    MuiInputBase: {
      styleOverrides: {
        sizeSmall: {
          fontSize: '0.75rem'
        },
        root: {
          '&.Mui-disabled': {
            color: '#8C8C8C !important',
            WebkitTextFillColor: '#8C8C8C!important'
          }
        },
        input: {
          '&.Mui-disabled': {
            color: '#8C8C8C !important',
            WebkitTextFillColor: '#8C8C8C !important'
          }
        }
      }
    }
  };
}
